import { createFileRoute } from "@tanstack/react-router";
import { AdminUsersView } from "@/components/admin/AdminUsersView";

export const Route = createFileRoute("/_authenticated/admin/users")({
  head: () => ({ meta: [{ title: "Users — Admin" }] }),
  component: AdminUsersPage,
});

function AdminUsersPage() {
  return <AdminUsersView />;
}
